//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
import "../Mechatronics/Mechatronics.SignalMappingConnectionBuilderList.js";
import "../Mechatronics/Mechatronics.MATLABSignalConnectionBuilderList.js";
import "../Mechatronics/Mechatronics.SHMSignalConnectionBuilderList.js";
import "../Mechatronics/Mechatronics.SignalConnectionBuilderList.js";
import "../no/ObjectList.js";
let d=[[[1,"ConnectionList",0,"Mechatronics.SignalMappingConnectionBuilderList",0],[1,"MATLABSignalConnectionList",0,"Mechatronics.MATLABSignalConnectionBuilderList",1],[1,"SHMSignalConnectionList",0,"Mechatronics.SHMSignalConnectionBuilderList",1],[1,"SignalConnectionList",0,"Mechatronics.SignalConnectionBuilderList",1]],[[["tgFolder"],"SetFolder",{},1,0]],[]];
SPLM.Mechatronics.SignalMappingBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.SignalMappingBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.SignalMappingBuilder.AppOption = Object.freeze({
    "Opcda" : "Opcda", "Opcua" : "Opcua", "Shm" : "Shm", "Matlab" : "Matlab", "Plcsimadv" : "Plcsimadv", "Tcp" : "Tcp", "Udp" : "Udp", "Profinet" : "Profinet", "Fmu" : "Fmu", "Sinumerik" : "Sinumerik", "Ethernetip" : "Ethernetip"});

export default SPLM;